"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDistributionWidget = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const attribute_distribution_styles_1 = require("./attribute-distribution.styles");
const hooks_1 = require("./hooks");
const dashboard_widget_1 = __importDefault(require("../dashboard-widget"));
const use_attribute_distribution_hook_1 = require("./hooks/use-attribute-distribution.hook");
const dashboard_widget_styles_1 = require("../dashboard-widget/dashboard-widget.styles");
const client_constants_1 = require("../../client/client.constants");
const table_error_overlay_1 = require("../../common/table-error-overlay");
const table_pagination_1 = require("../../common/table-pagination");
const use_table_loading_state_1 = require("../../common/use-table-loading-state");
const localization_1 = require("../../../localization");
const AttributeDistributionWidget = ({ className, selectedProductTreeNodeId, catalogId, productTreeId, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const { sortModel, setSortModel, } = (0, ui_components_1.useSorting)({});
    const columns = (0, hooks_1.useAttributeDistributionColumns)();
    const { data: { attributes }, error, isLoading, onSearch, refetch, pageInfo, totalCount, lastVariables, } = (0, use_attribute_distribution_hook_1.useAttributeDistribution)({
        catalogId,
        productTreeId,
        productTreeNodeId: selectedProductTreeNodeId,
        sortModel,
        searchQuery: searchTerm && searchTerm.trim().length > 3 ? searchTerm : undefined,
    });
    const { paginationModel, onPaginationModelChange, } = (0, table_pagination_1.useOffsetCursorPaginationAdapter)({
        refetch,
        totalCount,
        startCursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.startCursor,
    });
    const dataGridLoadingState = (0, use_table_loading_state_1.useTableLoadingState)({
        requestVariables: lastVariables,
        isLoading,
        hasError: Boolean(error),
    });
    const handleSearch = (newSearchTerm) => {
        setSearchTerm(newSearchTerm);
        onSearch(newSearchTerm);
    };
    const widgetTitle = (react_1.default.createElement(attribute_distribution_styles_1.StyledWidgetHeading, null, react_1.default.createElement(dashboard_widget_styles_1.StyledDashboardWidgetTitle, null, t({ key: 'ATTRIBUTE_DISTRIBUTION' })), react_1.default.createElement(attribute_distribution_styles_1.StyledSearchBar, { searchTerm: searchTerm, onSearch: handleSearch })));
    return (react_1.default.createElement(dashboard_widget_1.default, { className: className, title: widgetTitle }, react_1.default.createElement(ui_components_1.AdvancedDataGrid, { columns: columns, rows: attributes, loading: dataGridLoadingState.loading, rowCount: totalCount, checkboxSelection: false, disableRowSelectionOnClick: true, sortingMode: "server", sortModel: sortModel, onSortModelChange: setSortModel, paginationMode: "server", pagination: true, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, pageSizeOptions: client_constants_1.PAGE_SIZES, slots: {
            basePagination: ui_components_1.PaginationContainer,
            noRowsOverlay: error ? table_error_overlay_1.TableErrorOverlay : ui_components_1.DataGridNoResults,
        }, slotProps: {
            noRowsOverlay: { noResultsText: (error === null || error === void 0 ? void 0 : error.message) || t({ key: 'NO_DATA_AVAILABLE' }) },
            basePagination: {
                enablePageSizeSelectorControl: true,
                enablePageNavigation: true,
                enableEdgeButtons: true,
                rowsPerPageOptions: client_constants_1.PAGE_SIZES,
            },
            loadingOverlay: {
                variant: 'skeleton',
                noRowsVariant: 'skeleton',
            },
        }, showCellVerticalBorder: true, showColumnVerticalBorder: true })));
};
exports.AttributeDistributionWidget = AttributeDistributionWidget;
